var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.87v-1.69a1.51 1.51 0 0 0-2.5-1.14l-7.5 6.48 7.46 6.93a1.51 1.51 0 0 0 2.54-1.1v-1.63h12.47c1.22 0 2.22-1 2.22-2.22v-3.4c0-1.23-1-2.23-2.22-2.23H22.5zM27.19 28.25v-1.7a1.51 1.51 0 0 1 2.5-1.13l7.5 6.48-7.46 6.93a1.51 1.51 0 0 1-2.54-1.11v-1.63H14.72c-1.23 0-2.22-1-2.22-2.22v-3.4c0-1.23 1-2.22 2.22-2.22H27.2z",
    fill: "#FFF"
  })));
});